module.exports = __webpack_public_path__ + "static/media/Mihir Patel _ Resume.88e6cf9d.pdf";